import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c2a7ae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["transform"]

import { useStore } from "../store";
import { Ref, ref, computed } from "vue";
import BlockVue from "@/components/Block.vue";
import Tooltip from "@/components/tooltip/Tooltip.vue";
import BlockDescription from "./tooltip/BlockDescription.vue";
import type { FinalBlock } from "@/utils/block";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    blockClass: null
  },
  setup(__props: any) {

const props = __props as {
  blockClass: FinalBlock;
}



const blockElem: Ref<HTMLElement | null> = ref(null);
const block = ref(new props.blockClass());
const { addTempBlock } = useStore();
let isDown = false;
const down = () => {
  isDown = true;
};
const move = (e: PointerEvent) => {
  if (
    isDown &&
    blockElem.value !== null &&
    Math.abs(e.movementX ** 2 + e.movementY ** 2) > 0.1
  ) {
    const boundingRect = blockElem.value.getBoundingClientRect();
    addTempBlock(block.value, [
      boundingRect.x,
      boundingRect.y + boundingRect.height - block.value.design.bottomAnchor,
    ]);
    block.value = new props.blockClass();
    isDown = false;
  }
};
const up = () => {
  isDown = false;
};
const blockRect: Ref<DOMRect | null> = ref(null);
const showDescription = ref(false);
let enterTimeoutId: number | null = null;
let leaveTimeoutId: number | null = null;
const pointerenter = () => {
  if (leaveTimeoutId !== null) {
    clearTimeout(leaveTimeoutId);
    leaveTimeoutId = null;
  }
  enterTimeoutId = setTimeout(() => {
    enterTimeoutId = null;
    blockRect.value = blockElem.value?.getBoundingClientRect() ?? null;
    showDescription.value = true;
  }, 300);
};
const pointerleave = () => {
  if (enterTimeoutId !== null) {
    clearTimeout(enterTimeoutId);
    enterTimeoutId = null;
  }
  leaveTimeoutId = setTimeout(() => {
    leaveTimeoutId = null;
    showDescription.value = false;
  }, 100);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tray-block",
    onPointerdown: down,
    onPointermove: move,
    onPointerup: up,
    onPointerenter: pointerenter,
    onPointerleave: pointerleave,
    ref_key: "blockElem",
    ref: blockElem,
    style: _normalizeStyle({ transform: `translateY(${block.value.design.bottomAnchor}px)` })
  }, [
    _createVNode(Tooltip, {
      rect: blockRect.value,
      show: showDescription.value
    }, {
      default: _withCtx(() => [
        _createVNode(BlockDescription, { block: block.value }, null, 8, ["block"])
      ]),
      _: 1
    }, 8, ["rect", "show"]),
    (_openBlock(), _createElementBlock("svg", {
      width: block.value.design.width,
      height: block.value.design.height + block.value.design.bottomAnchor
    }, [
      _createElementVNode("g", {
        transform: `translate(0, ${block.value.design.height})`
      }, [
        _createVNode(BlockVue, {
          x: 0,
          y: 0,
          block: block.value,
          "update-block": (updater) => updater(block.value)
        }, null, 8, ["block", "update-block"])
      ], 8, _hoisted_2)
    ], 8, _hoisted_1))
  ], 36))
}
}

})